export default "__VITE_ASSET__DePlSGXv__"